import React, { useState, useRef, useEffect } from 'react';
import "./MaintenanceDiscard.css";
import Modal from "./Modal";
import { useTranslation } from 'react-i18next';

const TextBlock = ({ title, text }) => {
  const [showModal, setShowModal] = useState(false);
  const [textOverflow, setTextOverflow] = useState(false);
  const textRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    const el = textRef.current;
    if (el) setTextOverflow(el.scrollHeight > el.clientHeight);
  }, [text]);

  return (
    <div className="longtext-container">
      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title={title}>
        {text}
      </Modal>
      <div className="longtext-title">{title}</div>
      {text ? (
        <>
          <div
            ref={textRef}
            className="longtext-text"
            dangerouslySetInnerHTML={{ __html: text }}
          />
          {/* {!showModal && textOverflow && (
            <button className="see-more-button" onClick={() => setShowModal(true)}>
              <img
                alt="see-more-button-eye"
                src="/images/see-more-button-eye.svg"
                className="see-more-button-eye-img"
              />
              {t('see-more')}
            </button>
          )} */}
        </>
      ) : (
        <div className="longtext-text centered-text">
          <p>{t('the-information-was-not-provided')}</p>
        </div>
      )}
    </div>
  );
};

const MaintenanceDiscard = ({ repair_text, discard_text }) => {
  const { t } = useTranslation();

  return (
    <div className="maintenance-discard-blocks">
      <TextBlock title={t('repair-instructions')} text={repair_text} />
      <TextBlock title={t('discard-instructions')} text={discard_text} />
    </div>
  );
};

export default MaintenanceDiscard;
